// extracted by mini-css-extract-plugin
export default {"limitWidth":"retrievedTagInfo_limitWidth__vzV4m"};